import { useEffect, useState, useRef } from "react";
import { IOptions } from "../../../../component/Select";
import IC_MORE from "@/assets/record/ic_more_mobile.svg";
import FILEDELETE from "@/assets/record/ic_file_delete.svg?react";
import {
  SimpleRecord,
  collectRecord,
  cancelCollectRecord,
  deleteRecord,
  RenameRecord,
  deleteShareRecord,
  collectShareRecord,
  cancelCollectShareRecord,
} from "@/services/api_list";
import COLLECT from "@/assets/record/ic_collect_mobile.svg?react";
import { useNavigate } from "react-router-dom";
import IC_CLOSE_WIN from "@/assets/common/ic_close_win.svg?react";
import { formatRecordTime } from "@/utils/formatter";
import IC_CARD_PENDING from "@/assets/simulInter/ic_card_pending.svg";
import IC_CARD_RECORDING from "@/assets/simulInter/ic_card_recording.svg";
import { message } from "antd";
import { formatCreateDate } from "../util";
import { recordTitleMaxLen } from "@/constants/record";
import fridayReporter from "@/utils/friday";
import CardTitle, { CardTitleRef } from "../CardTitle";
import MobileInputModal, {
  MobileInputModalRef,
} from "@/component/MobileInputModal";
import MobileConfirmModal from "@/component/MobileConfirmModal";
import OriginPlateIcon from "@/assets/summary/ic_origin_plate.svg?react";
import SpeakerAvatar from "@/pages/Voice/SpearkerAvatar";
import BottomActionSheet from "@/component/BottomActionSheet";
import { openShareSheet } from "@/sections/ShareActionSheet";
import { ControllerStatus } from "@/types/simulInter";

interface IProp {
  isDeleted: boolean | null;
  model: SimpleRecord;
  handleCallback: (newModel: SimpleRecord) => void;
  deleteCallback: () => void;
  cancelCollectCallback: (newModel: SimpleRecord) => void;
}

export default function ItemGrid(prop: IProp) {
  const navigate = useNavigate();

  const {
    isDeleted,
    model,
    handleCallback,
    deleteCallback,
    cancelCollectCallback,
  } = prop;

  const [options, setOptions] = useState<Array<IOptions>>([
    { id: "rename", label: "重命名" },
    { id: "collect", label: "收藏" },
    { id: "share", label: "分享" },
    { id: "delete", label: "删除" },
  ]);

  const [showMore, setShowMore] = useState(false);
  const [showSelect, setShowSelect] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [title, setTitle] = useState("");

  const cardTitleRef = useRef<CardTitleRef>(null);
  const titleRenameModalRef = useRef<MobileInputModalRef>(null);

  useEffect(() => {
    setTitle(model.title);
    const newOptions = [...options];
    if (model.collect) {
      const collectIndex = newOptions.findIndex((item) => item.id === "collect");
      if (collectIndex !== -1) {
        newOptions[collectIndex] = { id: "cancelCollect", label: "取消收藏" };
      }
    }
    // 与我分享的，录制中和准备中的不允许重命名
    if (model.shareForMe || model.controllerStatus === ControllerStatus.PENDING || model.controllerStatus === ControllerStatus.RECORDING) {
      const renameIndex = newOptions.findIndex((item) => item.id === "rename");
      newOptions.splice(renameIndex, 1);
    }

    // 录制中和准备中的不允许分享
    if (model.controllerStatus === ControllerStatus.PENDING || model.controllerStatus === ControllerStatus.RECORDING) {
      const shareIndex = newOptions.findIndex((item) => item.id === "share");
      newOptions.splice(shareIndex, 1);
    }
    setOptions(newOptions);
  }, []);

  const choseHandle = async (value: IOptions) => {
    switch (value.id) {
      case "rename": {
        titleRenameModalRef.current?.open(title);
        break;
      }
      case "collect": {
        fridayReporter.pushData({
          eventCode: "HomePage_ListManage_Favorite",
        });
        let res: boolean;
        if (model.shareForMe) {
          res = await collectShareRecord(model.streamName);
        } else {
          res = await collectRecord(model.streamName);
        }

        if (res) {
          const index = options.findIndex((item) => item.id === "collect");
          options[index] = { id: "cancelCollect", label: "取消收藏" };
          setOptions(options);
          model.collect = true;
          handleCallback(model);
          message.success("收藏成功");
        } else {
          message.error("收藏失败");
        }
        break;
      }
      case "cancelCollect": {
        let res: boolean;
        if (model.shareForMe) {
          res = await cancelCollectShareRecord(model.streamName);
        } else {
          res = await cancelCollectRecord(model.streamName);
        }
        if (res) {
          const index = options.findIndex((item) => item.id === "cancelCollect");
          options[index] = { id: "collect", label: "收藏" };
          setOptions(options);
          model.collect = false;
          cancelCollectCallback(model);
          message.success("已取消收藏");
        } else {
          message.error("取消收藏失败");
        }
        break;
      }
      case "share": {
        fridayReporter.pushData({
          eventCode: "HomePage_ListManage_Share",
        });
        openShareSheet({
          visible: true,
          streamName: model.streamName,
          title: model.title
        });
        break;
      }
      case "delete": {
        setShowDialog(true);
        break;
      }
    }
    setShowMore(!showMore);
    setShowSelect(!showSelect);
  };

  const inputBlur = async (newTitle: string) => {
    if (model.title === newTitle) return;
    const res = await RenameRecord(model.streamName, newTitle);
    if (res) {
      model.title = newTitle;
      setTitle(newTitle);
      handleCallback(model);
      fridayReporter.pushData({
        eventCode: "HomePage_ListManage_Rename",
      });
    } else {
      setTitle(model.title);
    }
  };

  const cancleDlelete = () => {
    setShowDialog(false);
  };

  const confirmDlelete = async () => {
    fridayReporter.pushData({
      eventCode: "HomePage_ListManage_Delete",
    });
    setShowDialog(false);
    let res: boolean;
    if (model.shareForMe) {
      res = await deleteShareRecord(model.streamName);
    } else {
      res = await deleteRecord(model.streamName);
    }
    if (res) {
      message.success("删除成功");
      deleteCallback();
    } else {
      message.error("删除失败");
    }
  };

  const itemHandle = () => {
    if (isDeleted) return;
    fridayReporter.pushData({
      eventCode: "HomePage_EnterSummaryPage",
    });

    // 只有准备中和录制中状态才跳转到同传页面
    const isPendingOrRecording = model.controllerStatus === ControllerStatus.PENDING ||
      model.controllerStatus === ControllerStatus.RECORDING;

    if (isPendingOrRecording) {
      message.warning('移动端无法控制加入');
    } else {
      navigate({
        pathname: "/summary",
        search: `?streamId=${model.streamName.replace("live/", "")}`,
      });
    }
  };

  const showMoreHandle = async () => {
    setShowSelect(true);
  };

  return (
    <div
      className={` mb-4 ${model.coverUrl ? "min-h-75.5" : "min-h-68"
        } bg-white rd-2.5 py-5 flex flex-col justify-between relative`}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onClick={itemHandle}
    >
      {model.collect && (
        <COLLECT className="w-8 h-8 absolute top-0 right-0"></COLLECT>
      )}
      <MobileConfirmModal
        visible={showDialog}
        title="确定删除"
        content="删除后，将无法恢复"
        onCancel={cancleDlelete}
        onConfirm={confirmDlelete}
      />
      {isDeleted ? (
        <div className="flex flex-col mx-4 flex-1">
          <div className="flex justify-between">
            <span className="text-size-3.5 text-mx-secondary">
              抱歉，此内容无法查看
            </span>
            <IC_CLOSE_WIN
              className="w-5 h-5"
              onClick={(e) => {
                e.stopPropagation();
                confirmDlelete();
              }}
            ></IC_CLOSE_WIN>
          </div>
          <FILEDELETE className="w-12 h-17.58 self-center mt-12"></FILEDELETE>
          <span className="text-size-3.5 text-mx-quaternary mt-4.2 self-center">
            源文件已删除
          </span>
        </div>
      ) : (
        <div className="flex flex-col mx-4">
          <div
            className="h-fit mb-4 min-h-11"
            onClick={(e) => {
              if (!model.shareForMe) {
                e.stopPropagation();
              }
            }}
          >
            <CardTitle
              ref={cardTitleRef}
              initialText={title}
              maxLength={recordTitleMaxLen}
              inputBlur={inputBlur}
            />
          </div>
          {/* 根据controllerStatus判断显示内容 */}
          {model.controllerStatus === ControllerStatus.PENDING ? (
            // 待录制状态：显示待录制占位图
            <div className="w-full mb-4 rd-1 flex items-center justify-center">
              <img src={IC_CARD_PENDING} className="w-full h-full object-contain" />
            </div>
          ) : model.controllerStatus === ControllerStatus.RECORDING ? (
            // 正在录制状态：显示正在录制占位图
            <div className="w-full mb-4 rd-1 flex items-center justify-center">
              <img src={IC_CARD_RECORDING} className="w-full h-full object-contain" />
            </div>
          ) : (
            // 完成状态：显示封面或总结
            model.coverUrl ? (
              <img
                src={model.coverUrl}
                className="w-full object-cover mb-4 rd-1 bg-#F4F6F9"
              />
            ) : (
              <div className="mx-1 text-size-3 text-mx-quaternary lh-5.5 mb-1 line-clamp-4 b-t-solid border-#F4F6F9 b-1px pt-4">
                <span>
                  {model.summaryRecord.meetingSummary == null
                    ? "等待内容生成"
                    : model.summaryRecord.meetingSummary[0]}
                </span>
              </div>
            )
          )}
        </div>
      )}
      {!isDeleted && (
        <div className="min-h-6 flex items-center text-mx-quaternary text-size-3 justify-between mx-4">
          <div className="flex items-center w-[calc(100%-1.125rem)]">
            {model?.origin === "MAXHUB会议平板" ? (
              <OriginPlateIcon className="size-6" />
            ) : (
              <SpeakerAvatar
                className={`size-6 text-2.25 min-w-6`}
                avatarIndex={0}
                speakerName={model.origin}
              />
            )}
            <span className="mx-2 mx-text-ellipsis">{model.origin}</span>
            <span className="whitespace-nowrap">
              {formatCreateDate(model.createdDate)}
            </span>
            <div className="h-2.5 w-0.25 bg-#ECEEF3 rd-0.5 mx-2"></div>
            {/* 根据controllerStatus显示不同状态 */}
            {model.controllerStatus === ControllerStatus.PENDING ? (
              <span className="mr-2 whitespace-nowrap">准备中</span>
            ) : model.controllerStatus === ControllerStatus.RECORDING ? (
              <span className="mr-2 whitespace-nowrap text-mx-primary">录制中…</span>
            ) : (
              <span className="mr-2 whitespace-nowrap">
                时长 {formatRecordTime(model.duration ?? 0)}
              </span>
            )}
          </div>
          <img
            className="w-4 h-4"
            src={IC_MORE}
            onClick={(e) => {
              e.stopPropagation();
              showMoreHandle();
            }}
          ></img>
        </div>
      )}

      <BottomActionSheet visible={showSelect} setVisible={setShowSelect} title={title}>
        <>
          {options.map((option) => {
            return (
              <div
                key={option.id}
                className={`py-3.5 hover:bg-#F4F6F9 ${option.id === "delete" ? "text-mx-error" : "text-mx-secondary"
                  }`}
                onClick={() => choseHandle(option)}
              >
                {option.label}
              </div>
            );
          })}
        </>
      </BottomActionSheet>

      <MobileInputModal ref={titleRenameModalRef} updateValue={inputBlur} />

      {!model.viewed && (
        <div className="absolute top--.5 left--.5 w-3 h-3 bg-#FF584C rounded-full"></div>
      )}
    </div>
  );
}
